import { SET_PREMIUM } from './premium.action';

const INITIAL_STATE = {
    isPremium: false,
};

export default function premiumReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_PREMIUM:
            return {
                ...state,
                isPremium: action.payload,
            };

        default:
            return state;
    }
}
